import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import NodeViewModel from "./../../factories/node-view-model";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TabPage from "./../../factories/tab-page";
import BaoDialogViewModel from "./../../factories/bao-dialog";
// bao migrate - module not found: import "services/bao-template-engine";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import "./../../bindings/sorting";
function ConfigurationItemSoftwareInventoryTabModel(tabPage, parent) {
    var self = this;
    self.Bao = Bao;
    self.ConfigurationItem = parent;
    self.CompleteCheck = function () {
        return true;
    };
    self.PageIndex = ko.observable(0);
    self.PageIndex.subscribe(function () {
        self.RefreshGrid();
    });
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.Sorting.subscribe(function () {
        self.RefreshGrid();
    });
    self.SoftwareInventoryCollection = ko.observableArray([]);
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemSoftwareInventoryCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedSoftwareInventoryRow(null);
            self.TotalRows(0);
            self.SoftwareInventoryCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.SoftwareInventoryCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.SelectedSoftwareInventoryRow = ko.observable({});
    self.Refresh = function () {
        var def = $.Deferred();
        Bao.post("ConfigurationItemTab/ResetConfigurationItemSoftwareInventoryCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId
        }), function () {
            self.RefreshGrid().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    self.Save = function () { };
    self.init = function () {
        return self.Refresh();
    };
    self.loaded = function () { };
}
;
export default ConfigurationItemSoftwareInventoryTabModel;